import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import './App.css';
import LoginPage from "./pages/LoginPage";
import OrdersPage from "./pages/OrdersPage";
import ConsumerPage from "./pages/ConsumerPage";
import AdminPage from "./pages/AdminPage";
import UserPage from "./pages/UserPage";
import NotFoundPage from "./pages/NotFoundPage";
import "react-toastify/dist/ReactToastify.css";
import UserDashboard from "./pages/UserDashboard";
import ConsumerMenu from './pages/ConsumerMenu'
import { AuthProvider } from "./state/AuthContext";
import ProtectedRoute from "./utils/ProtectedRoute";
import Admin from "./pages/AdminPage";
import HomePage from "./pages/HomePage";
import OnboardingForm from "./pages/OnboardingForm"
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
function App() {
  // const user = {
  //   isAuthenticated: true, // Simulate 
  //   role: "admin",
  // };

  // const RoleBasedRoute = ({ role, children }) => {
  //   return user.isAuthenticated && user.role === role ? (
  //     children
  //   ) : (
  //     <Navigate to="/login" />
  //   );
  // };
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/user"
            element={
              <ProtectedRoute role="user">
                <UserDashboard />
              </ProtectedRoute>
            }
          />
           <Route
            path="/orders"
            element={
              <ProtectedRoute role="user">
                <OrdersPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<ConsumerPage />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/:id" element={<ConsumerPage />} />
          <Route path="/Onboarding" element={<OnboardingForm />} />

          <Route path="/menu/:businessId" element={<ConsumerMenu />} />
        </Routes>
      </Router>
    </AuthProvider>
    // <Router>
    //   <Routes>
    //     {/* Public Route */}
    //     <Route path="/" element={<LoginPage />} />

    //     {/* Consumer Route */}
        
    //      <Route path="/:id" element={<ConsumerPage />} />



    //     {/* Admin Route */}
    //     <Route
    //       path="/admin"
    //       element={
    //         // <RoleBasedRoute role="admin">
    //           <AdminPage />
    //         // </RoleBasedRoute>
    //       }
    //     />

    //     {/* User Route */}
    //     <Route
    //       path="/user"
    //       element={
    //         // <RoleBasedRoute role="user">
    //           <UserPage />
    //         // </RoleBasedRoute>
    //       }
    //     />
    //     <Route
    //       path="/userDashboard"
    //       element={
    //         // <RoleBasedRoute role="user">
    //           <UserDashboard />
    //         // </RoleBasedRoute>
    //       }
    //     />
    //      <Route
    //       path="/consumerMenu"
    //       element={
    //         // <RoleBasedRoute role="admin">
    //           <ConsumerMenu />
    //         // </RoleBasedRoute>
    //       }
    //     />

    //     {/* Catch-All Route */}
    //     {/* <Route path="*" element={<NotFoundPage />} /> */}
    //   </Routes>
    // </Router>
  );
}

export default App;
